module.exports = __webpack_public_path__ + "img/outlined_people-flipped.15a388ed.png";